export default "__VITE_ASSET__59fdbfa0__"